import defaultType from "./types/default.js";
import lib from "./types/index.js";
/**
 * Get a type processor by type name, optionally scoped to a kind.
 * @param type - The type name.
 * @param kind - Optional kind to scope the search.
 * @param custom - Optional custom overrides.
 * @returns The type processor.
 */
export function getType(type, kind, custom) {
    if (kind) {
        if (lib[kind]?.[type]) {
            return { ...defaultType, ...lib[kind][type], ...custom };
        }
    }
    else {
        for (const kindKey in lib) {
            if (lib[kindKey]?.[type]) {
                return {
                    ...defaultType,
                    ...lib[kindKey].default,
                    ...lib[kindKey][type],
                    ...custom,
                };
            }
        }
    }
    return { ...defaultType };
}
/**
 * Get all type processors for a given kind.
 * @param kind - The kind name.
 * @param custom - Optional custom overrides.
 * @returns Array of type processors.
 */
export function getAllTypes(kind, custom) {
    const all = [];
    for (const type in lib[kind]) {
        if (type !== 'default') {
            all.push(getType(type, kind, custom));
        }
    }
    return all;
}
//# sourceMappingURL=typeUtils.js.map